import { connect } from "react-redux";
import SocialTopics from "../components/SocialTopics";
var mapStateToProps = function(state, _ownProps) {
    return {
        currentUser: state.session,
        topics: state.topics.allTopics,
        notes: state.notes.notes,
        isLoadingNotes: state.loading.indexOf("fetch_notes") > -1,
        isLoadingTopics: state.loading.indexOf("fetch_topics") > -1
    };
};
export default connect(mapStateToProps)(SocialTopics);
